import { CompileTimeConstants } from './CompileTimeConstants'

export function shouldMockExternalApis(): boolean {
  const isRunningLocally = CompileTimeConstants.isLocal

  // Agave case
  if (window.location.pathname.startsWith('/officeaddins')) {
    const windowIsTopLevelFrame = !window.parent || window.parent === window
    return isRunningLocally && windowIsTopLevelFrame
  }

  // OneNote.Com/stickynotes case
  const isRunningInOneNoteDotComInt = window.location.hostname.endsWith('onenote-int.com')
  const isRunningInOneNoteDotCom = window.location.hostname.endsWith('onenote.com')

  // Only if we're running locally and we're not running in onenote.com
  return !( isRunningInOneNoteDotCom || isRunningInOneNoteDotComInt ) && isRunningLocally
}
